import { render } from "./SignupSelection.vue?vue&type=template&id=5345d5f4&scoped=true"
import script from "./SignupSelection.vue?vue&type=script&lang=js"
export * from "./SignupSelection.vue?vue&type=script&lang=js"

import "./SignupSelection.vue?vue&type=style&index=0&id=5345d5f4&lang=scss&scoped=true"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5345d5f4"]])

export default __exports__